import { Button, Result } from "antd";
import { nextPage } from "../../util/library/Router";
import { PATHNAME } from "../../util/varibles/constants";
import styles from "./style.module.scss";

const NotAuthorizedPage = () => {
    return <div className={[styles.wrapper, 'bgPage'].join(' ')}>
        <Result
            status="403"
            title={<div className='font-s16 font-w5'>Unauthorized</div>}
            subTitle="Sorry, you are not authorized to access this page."
            extra={<div className="flex justify-center">
                <Button className='bt-primary' onClick={() => nextPage(PATHNAME.HOME)}>Back Dashboard</Button>
            </div>}
        />
    </div>;
}

export default NotAuthorizedPage;